module.exports = __webpack_public_path__ + "media/images/flags/4x3/ken-55d663b2ec8bbc63989c3db7b4efcd3f.svg";